export enum PrimaryContactDialogType {
  REPLACE_PRIMARY_WARNING = "REPLACE_PRIMARY_WARNING",
  REMOVE_PRIMARY_WARNING = "REMOVE_PRIMARY_WARNING",
  SET_NEW_PRIMARY = "SET_NEW_PRIMARY",
}
